"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const StandaloneTile = (_a, ref) => {
    var { layer, layers = [], border = false, resourceManager, tileSize = 32 } = _a, props = __rest(_a, ["layer", "layers", "border", "resourceManager", "tileSize"]);
    if (layer && layers.length > 0) {
        throw Error("StandaloneTile should not recieve both layer and layers props");
    }
    if (layer) {
        layers = [layer];
    }
    const [canvasRef, setCanvasRef] = react_1.useState(undefined);
    const callbackRef = react_1.useCallback((node) => {
        if (node !== null) {
            setCanvasRef(node);
        }
    }, []);
    if (canvasRef) {
        const context = canvasRef.getContext("2d", {
            alpha: false,
        });
        context.imageSmoothingEnabled = false;
        context.clearRect(0, 0, tileSize, tileSize);
        layers.forEach((layer) => {
            var _a;
            const resource = resourceManager.getResource(layer.resourceID);
            const spriteSize = (_a = resource.spriteSize) !== null && _a !== void 0 ? _a : tileSize;
            const sprite = resource.layers[layer.layerID].sprite;
            context.drawImage(resourceManager.getImg(layer.resourceID), sprite.x * spriteSize, sprite.y * spriteSize, spriteSize, spriteSize, 0, 0, tileSize, tileSize);
        });
        if (border) {
            context.beginPath();
            context.rect(0, 0, tileSize, tileSize);
            context.strokeStyle = "#000";
            context.lineWidth = 1;
            context.stroke();
            context.closePath();
        }
    }
    return (react_1.default.createElement("div", Object.assign({ ref: ref }, props, { className: "d-flex align-items-center m-1" }),
        react_1.default.createElement("canvas", { height: tileSize, width: tileSize, ref: callbackRef })));
};
exports.default = react_1.forwardRef(StandaloneTile);
//# sourceMappingURL=StandaloneTile.js.map